import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { EoFormPanelConfig } from '../eo-form-panel/eo-form-panel.model';

export interface IFormComponent {
  validate(): boolean;
}

export interface IFormValidationError {
  [key: string]:
    | string
    | {
        required?: string;
        minlength?: string;
        maxlength?: string;
        pattern?: string;
        email?: string;
        min?: string;
        max?: string;
        nullValidator?: ''; // No error message for nullValidator
      };
}

export interface IEoFormControlConfig {
  name: string;
  component?: any;
  tabIndex?: number;
  styleClass?: string;
  type?: any;
  visible?: boolean | ((event: any) => boolean);
  removable?: boolean;
  canBeNotApplicable?: boolean;
  notApplicableLabel?: string;
  hidden?: boolean;
  control: FormControl<any>;
  label?: string;
  help?: string;
  errors?: IFormValidationError;
  onRemove?: (event: any) => void;
  onChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  onFocus?: (event: any) => void;
}

export abstract class EoFormControlConfig implements IEoFormControlConfig {
  name: string;
  component?: any;
  tabIndex?: number;
  styleClass?: string;
  type?: any;
  visible?: boolean | ((event: any) => boolean);
  removable?: boolean;
  canBeNotApplicable?: boolean;
  notApplicableLabel?: string;
  hidden?: boolean;
  control: FormControl<any>;
  label?: string;
  help?: string;
  errors?: IFormValidationError;
  onRemove?: (event: any) => void;
  onChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  onFocus?: (event: any) => void;

  constructor();
  constructor(obj: IEoFormControlConfig);
  constructor(obj?: IEoFormControlConfig) {
    this.name = obj?.name ?? '';
    this.component = obj?.component;
    this.styleClass = obj?.styleClass;
    this.tabIndex = obj?.tabIndex;
    this.type = obj?.type ?? '';
    this.control = obj?.control!;
    this.label = obj?.label;
    this.help = obj?.help;
    this.removable = obj?.removable;
    this.canBeNotApplicable = obj?.canBeNotApplicable;
    this.notApplicableLabel = obj?.notApplicableLabel;
    this.visible = obj?.visible;
    this.hidden = obj?.hidden;
    this.errors = obj?.errors;
    this.onChange = obj?.onChange;
    this.onBlur = obj?.onBlur;
    this.onFocus = obj?.onFocus;
    this.onRemove = obj?.onRemove;
  }
}

export class EoCustomControlConfig extends EoFormControlConfig {
  override type = 'custom';

  constructor();
  constructor(obj: IEoFormControlConfig);
  constructor(obj?: IEoFormControlConfig) {
    super(obj!);
  }
}

export interface IFormConfig {
  config: IEoFormControlConfig[];
}

export class FormConfig implements IFormConfig {
  config: EoFormControlConfig[];

  public getFormGroup(): FormGroup {
    let formGroup: any = {};
    this.config.forEach((c) => (formGroup[c.name] = c.control));
    return formGroup;
  }

  public getFormControl(formControlName: string): FormControl | undefined {
    return (
      this.config.find((c) => c.name === formControlName)?.control ?? undefined
    );
  }

  public getHelp(formControlName: string): string | undefined {
    return (
      this.config.find((c) => c.name === formControlName)?.help ?? undefined
    );
  }

  public getErrors(formControlName: string): IFormValidationError | undefined {
    return (
      this.config.find((c) => c.name === formControlName)?.errors ?? undefined
    );
  }

  constructor();
  constructor(obj: IFormConfig);
  constructor(obj?: IFormConfig) {
    this.config = obj?.config ?? [];
  }
}

export interface IEoFormConfig {
  id?: string;
  config: FormConfig[] | EoFormPanelConfig[];
  styleClass?: string;
  submitButtonVisible?: boolean;
  submitButtonLoading?: boolean;
  submitButtonLabel?: string;
  submitButtonStyleClass?: string;
  submitButtonDivStyleClass?: string;
  submitButtonIcon?: string;
  icon?: string;
  displayMode?: 'default' | 'groupLists';
  displayModeChangeVisible?: boolean;
}

export class EoFormConfig implements IEoFormConfig {
  id?: string;
  config: FormConfig[] | EoFormPanelConfig[];
  styleClass?: string;
  submitButtonVisible?: boolean;
  submitButtonLoading?: boolean;
  submitButtonLabel?: string;
  submitButtonStyleClass?: string;
  submitButtonDivStyleClass?: string;
  submitButtonIcon?: string;
  icon?: string;
  displayMode?: 'default' | 'groupLists';
  displayModeChangeVisible?: boolean;

  constructor();
  constructor(obj: IEoFormConfig);
  constructor(obj?: IEoFormConfig) {
    this.id = obj?.id;
    this.config = obj?.config ?? [];
    this.styleClass = obj?.styleClass ?? '';
    this.submitButtonVisible = obj?.submitButtonVisible ?? true;
    this.submitButtonLoading = obj?.submitButtonLoading ?? false;
    this.submitButtonLabel = obj?.submitButtonLabel ?? 'Αποθήκευση';
    this.submitButtonStyleClass = obj?.submitButtonStyleClass;
    this.submitButtonDivStyleClass = obj?.submitButtonDivStyleClass;
    this.submitButtonIcon = obj?.submitButtonIcon;
    this.icon = obj?.icon ?? '';
    this.displayMode = obj?.displayMode ?? 'default';
    this.displayModeChangeVisible = obj?.displayModeChangeVisible ?? false;
  }
}
//
